<template>
  <div>
    <HeaderInnerPage
      id="how-works"
      title="Como funciona a Pedale"
      :background="bgPage"
    >
       Uma Experiência de Aluguel de Bicicletas Conectada Localmente!
    </HeaderInnerPage>

    <section>
      <b-container>
        <b-row>
          <b-col cols="12" lg="8">

             <h3 class="mb-3">Entenda como funciona o Pedale</h3>
             <p class="lead mb-4"><slot>Na Pedale, estabelecemos conexões com anfitriões locais, permitindo que eles ofereçam suas bicicletas para aluguel por meio de nossa plataforma.</slot></p>

             <h4>Um olhar detalhado no processo Pedale:</h4>
             <ol class="pl-3">
                <li><strong>Cadastro e Organização Local:</strong> As bicicletas disponíveis são cuidadosamente organizadas por cidade, facilitando a busca por ciclistas que desejam encontrar a bicicleta ideal para sua próxima aventura.
                </li>
                <li><strong>Pesquisa e Reserva Simples:</strong> Navegue pelas opções de bicicletas disponíveis na cidade escolhida e faça a reserva com apenas alguns cliques. Tornamos o processo simples e eficiente.
                </li>
                <li><strong>Comunicação Direta e Avaliações Transparentes:</strong> Através do chat integrado, anfitriões e ciclistas podem trocar informações e garantir uma experiência de aluguel perfeita. Além disso, incentivamos avaliações transparentes para manter a qualidade do serviço.</li>
             </ol>
          </b-col>

           <b-col cols="12" lg="4" class="mb-4 mb-lg-0">
              <img class="img-fluid" src="../assets/img/voce-quer-alugar-sua-bicicleta.svg" alt="Icone"/>
           </b-col>
        </b-row>

         <b-row>
            <b-col class="text-center">
               <p class="lead">Experimente a facilidade e a conveniência de alugar uma bicicleta com a Pedale. Conecte-se com anfitriões locais e descubra a liberdade de explorar a cidade sobre duas rodas!</p>

               <img class="img-fluid mt-3" src="../assets/img/voce-quer-pedalar.svg" alt="Icone"/>
            </b-col>
         </b-row>



      </b-container>
    </section>

  </div>

</template>

<script>
    // @ is an alias to /src
    import bgPage from '@/assets/img/como-funciona-o-pedale.jpg';
    import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
    import {metaTags} from "@/helpers";

    export default {
        name: 'HowWorks',
        metaInfo: metaTags(`Como Funciona`),
        components: {
            HeaderInnerPage
        },
        data() {
            return {
                bgPage,
            }
        }
    }
</script>
